/**
 * Persisted maturity snapshots — read/write a small dictionary of completed
 * lite self-assessments keyed by sub-brand slug. Used by the PortfolioRadar
 * on /services to render a returning visitor's actual maturity polygon.
 *
 * Schema:
 *   localStorage["ekselens.maturity"] = JSON.stringify({
 *      [slug]: {
 *        slug, overall, level_label,
 *        by_dimension: [{ dimension_id, label, score }],
 *        updated_at: ISO,
 *      },
 *      ...
 *   })
 *
 * Defensive: every read/write is wrapped in try/catch so a broken/disabled
 * localStorage never crashes the page.
 */

const KEY = "ekselens.maturity";

export function getAllSnapshots() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (e) {
    // localStorage unavailable / corrupted JSON — return empty snapshot map.
    if (typeof console !== "undefined") console.warn("[maturitySnapshots] getAll failed:", e);
    return {};
  }
}

export function setSnapshot(slug, snapshot) {
  if (!slug || !snapshot) return;
  try {
    const all = getAllSnapshots();
    all[slug] = {
      slug,
      overall: snapshot.overall,
      level_label: snapshot.level_label,
      by_dimension: snapshot.by_dimension || [],
      updated_at: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch (e) {
    // localStorage disabled / quota exceeded — silently degrade.
    if (typeof console !== "undefined") console.warn("[maturitySnapshots] set failed:", e);
  }
}

export function clearSnapshots() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    if (typeof console !== "undefined") console.warn("[maturitySnapshots] clear failed:", e);
  }
}
